import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BundleSet, CartData, Item, ProductItem, ServicePlan } from 'src/app/shared-core/models/cart-data.model';
import { CartService } from '../../../shared-core/services/cart.service';
import { ComponentMessagingService } from 'src/app/shared-core/services/component-messaging.service';
import { Subscription } from 'rxjs';
import { MessageTopicsEnum } from 'src/app/shared-core/models/component-message.model';

@Component({
  selector: 'app-bundle-list',
  templateUrl: './bundle-list.component.html',
  styleUrls: ['./bundle-list.component.scss']
})
export class BundleListComponent implements OnInit, OnDestroy {
  @Input() bundleSet: BundleSet;
  @Input() Model: CartData;
  @Input() Spacer: boolean;

  html = '<span><i>Tooltip</i> <u>with</u> <b>HTML</b></span>';
  productListWaitingSubscription: Subscription;
  messagingSubscription: Subscription;
  constructor(public service: CartService, private messaging: ComponentMessagingService) { }
  IsWaiting: boolean;

  ngOnInit(): void {
    this.productListWaitingSubscription = this.service.isLoadingSubject.subscribe((waiting) => {
      this.IsWaiting = waiting;
    });

    this.messagingSubscription = this.messaging
      .onMessage(MessageTopicsEnum.CloseBundleBuilderRequest)
      .subscribe((msg) => {
        this.IsWaiting = false;
      });
  }

  get canEditBundle() {
    return this.Model.CartBundleEditables.find((x) => x.BundleId == this.bundleSet.BundleId)?.IsEditable ?? false;
  }

  public getImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    return 'https://img.vistek.net' + imgURI[0];
  }

  public changeItemQuantity(item: ProductItem, event: Event) {
    // if this is free item we don't allow qty lower that parents qty combined
    if (item.Attributes.IsBundleFreeItem) {
      const anchorItems = this.bundleSet.Items.filter((x) => x.Attributes.IsBundleAnchor);
      if (anchorItems.length > 0) {
        const totalAnchorQty = anchorItems.reduce((sum, cur) => sum + cur.Quantity, 0);
        // if this change will produce free item qty in bundle
        // to be lower then total anch qty we reject it
        if (item.Quantity < totalAnchorQty) {
          // reset it as event will not reset qty to original state
          item.Quantity = totalAnchorQty;
          event.preventDefault();
          return;
        }
      }
    }

    if (item.Quantity < 1) {
      item.Quantity = 1;
      return;
    }

    this.service.changeItemQuantity(item);
  }
  public saveItemForLater(item: Item) {
    this.service.saveItemForLater(item);
  }
  public removeItem(item: Item) {
    this.service.removeOrderItem(item);
  }
  public removeBundle(bundleId: number) {
    this.service.removeBundle(bundleId, this.bundleSet.Items);
  }

  public showBundleBuilder(event: Event) {
    this.IsWaiting = true;
    this.messaging.sendMessage(MessageTopicsEnum.EditBundleRequest, this.bundleSet);
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    this.productListWaitingSubscription.unsubscribe();
    this.messagingSubscription.unsubscribe();
  }
}
